import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import 'firebase/auth';
import 'firebase/storage';
import 'firebase/functions';

import config from 'config';

const firebaseConfig = config.firebase.config;

// This secondary app is used for user creation.
// By default in Firebase, when a user is created,
// it is automatically signed-in.
const firebaseSecondary = firebase.initializeApp(firebaseConfig, 'secondary');
firebaseSecondary.database();
firebaseSecondary.storage();
firebaseSecondary.firestore();

export default firebaseSecondary;
